import React from 'react';
import classNames from 'classnames';
import styles from './ButtonGroup.scss';

export interface ButtonGroupOption {
  label: string;
  value: string;
}

interface ButtonGroupProps {
  options: ButtonGroupOption[];
  selectedOption: string;
  onClick: (option: string) => void;
}

const ButtonGroup = ({ options, selectedOption, onClick }: ButtonGroupProps) => {
  return (
    <div className={styles.ButtonGroup}>
      {options.map(option => (
        <button
          key={option.value}
          className={classNames(styles.ButtonGroup__Button, {
            [styles.ButtonGroup__Button__selected]: selectedOption === option.value,
          })}
          onClick={() => onClick(option.value)}
          data-testid={`ButtonGroup__Option__${option.value}`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ButtonGroup;
